import BaseInfoView from "../ui/base_info_view"
import {
    Eye,
    MousePointer,
    FileText,
    TrendingUp,
    Edit, Share, Download,
} from "lucide-react"
import { Button, LucideIcon } from "../ui/ot"
import dayjs from 'dayjs'
const CrmInfoView = ({
    apiRoute = "/utility/document/base_on_classify_structure",
    reloadCount,
    reloadAndResetCount,
    propsGetBaseCardViewData,
    propsGetBaseListViewData,
    propsGetParams,
    fallbackText = "-",
    dateFormat = "YYYY-MM-DD",
    defaultThumbnailSrc = "https://open.ncl.edu.tw/pic/room/636869e192c94.jpg",
    treeFilterTitle = "分類篩選",
    statsLabelConfig = {},
    actionTextConfig = {},
    locationContent,
    propsRenderCardExtraContent,
    propsRenderListExtraContent,
    propsGetCategoryParams,
    searchTextConfig = {},
    viewModeTextConfig = {},
    categoryTabTextConfig = {},
    baseTreeSelectorProps = {},
    showComponent = [
        "BaseInfoView1",
        "BaseInfoView2",
        // "BaseInfoView3",
        // "BaseInfoView4",
        "BaseInfoView5",
        "BaseInfoView6",
    ],
    categoryData = [
        {
            key: "all",
            label: "",
            dark_mode_color: "#60a5fa",
            light_mode_color: "#f0f6ff",
        }
    ],

    showTreeFilter = false,
    FilterComponent = <></>,
    multipleEditComponent = <></>,
    showCardContent = false,
    FilterComponentCols = 6,
    CardContentData = <></>,
                
    ...props
}) => {
    const mergedStatsLabelConfig = {
        view: "瀏覽次數",
        write: "撰寫文案",
        click: "點擊次數",
        copy: "複製次數",
        ...statsLabelConfig,
    }
    const mergedActionTextConfig = {
        view: "查看",
        edit: "複製文案內容並編輯",
        share: "分享",
        export: "匯出",
        delete: "刪除",
        ...actionTextConfig,
    }
    const getBaseCardViewData = (data) => {
        let newdata = data.map((value) => {
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_culture_value || fallbackText

            return {
                key: value?.key,
                baseCardView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseCardView1_2Props: {
                    src: defaultThumbnailSrc
                },
                baseCardView1_3Props: {
                    value: twName,
                },
                baseCardView1_4Props: {
                    value: document_classify_structure_type_data_first?.document_description || fallbackText,
                },
                baseCardView1_5Props: {
                    stats: [
                        {
                            value: document_classify_structure_type_data_first?.view_times,
                            label: mergedStatsLabelConfig.view,
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"Eye"} className="h-4 w-4 text-blue-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.clone_times,
                            label: mergedStatsLabelConfig.write,
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"FileText"} className="h-4 w-4 text-green-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.click_times,
                            label: mergedStatsLabelConfig.click,
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"MousePointer"} className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: document_classify_structure_type_data_first?.copy_times,
                            label: mergedStatsLabelConfig.copy,
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"TrendingUp"} className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseCardView1_6Props: {
                    badges: [
                        {
                            label: document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(document_classify_structure_type_data_first?.create_time).format(dateFormat),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseCardView1_7Props: {
                    children: propsRenderCardExtraContent?.(value) ?? locationContent ?? <p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseCardView1_8Props: {
                    buttons: [
                        <Button variant="outline" className="flex-1">
                            <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.view}
                        </Button>,
                        <Button className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.edit}
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.share}
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.export}
                        </Button>,
                        <Button variant="ghost" size="sm" className="text-red-600">
                            {mergedActionTextConfig.delete}
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
            }
        })
        return newdata
    }
    const getBaseListViewData = (data) => {
        let newdata = data.map((value) => {
            let document_classify_structure_type_data = value?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((ele) => true)
            let name_language_data = value?.name_language_data || []
            let twName = name_language_data?.find((ele) => ele?.language_culture_code === "zh-tw")?.language_culture_value || fallbackText

            return {
                key: "1",
                baseListView1_1Props: {
                    checked: false,
                    onCheckedChange: () => { }
                },
                baseListView1_2Props: {
                    value: twName,

                },
                baseListView1_3Props: {
                    value: document_classify_structure_type_data_first?.document_description || fallbackText,
                },
                baseListView1_4Props: {
                    stats: [
                        {
                            value: document_classify_structure_type_data_first?.view_times,
                            label: mergedStatsLabelConfig.view,
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"Eye"} className="h-4 w-4 text-blue-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.clone_times,
                            label: mergedStatsLabelConfig.write,
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"FileText"} className="h-4 w-4 text-green-500" />
                        },
                        {
                            value: document_classify_structure_type_data_first?.click_times,
                            label: mergedStatsLabelConfig.click,
                            backgroundColor: "bg-blue-50",
                            animationDuration: 2000,
                            animationDelay: 0,
                            icon: <LucideIcon name={"MousePointer"} className="h-4 w-4 text-purple-500" />

                        },
                        {
                            value: document_classify_structure_type_data_first?.copy_times,
                            label: mergedStatsLabelConfig.copy,
                            backgroundColor: "bg-green-50",
                            animationDuration: 1500,
                            animationDelay: 200,
                            icon: <LucideIcon name={"TrendingUp"} className="h-4 w-4 text-orange-500" />

                        },
                    ]
                },
                baseListView1_5Props: {
                    badges: [
                        {
                            label: document_classify_structure_type_data_first?.create_user_name,
                            variant: "outline",
                            className: ""
                        },
                        {
                            label: dayjs(document_classify_structure_type_data_first?.create_time).format(dateFormat),
                            variant: "outline",
                            className: ""
                        },
                    ]
                },
                baseListView1_6Props: {
                    children: propsRenderListExtraContent?.(value) ?? locationContent ?? <p className="text-gray-600 mt-1 text-sm">儲存位置：.../.../...</p>
                },
                baseListView1_7Props: {
                    buttons: [
                        <Button variant="outline" className="flex-1">
                            <LucideIcon name={"Eye"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.view}
                        </Button>,
                        <Button className="flex-1">
                            <LucideIcon name={"Edit"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.edit}
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <LucideIcon name={"Share"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.share}
                        </Button>,
                        <Button variant="ghost" size="sm">
                            <LucideIcon name={"Download"} className="h-4 w-4 mr-1" />
                            {mergedActionTextConfig.export}
                        </Button>,
                        <Button variant="ghost" size="sm" className="text-red-600">
                            {mergedActionTextConfig.delete}
                        </Button>,
                    ],
                    buttonGroupsColumnsCount: [2, 3],
                },
            }
        })
        return newdata
    }

    const getParams = (keyArr, categoryDataValues) => {
        let params = {
        }
        if (keyArr.includes("history")) {
            params['is_finish'] = 1
        }
        if (keyArr.includes("ing")) {
            params['is_finish'] = 0
        }
        if (categoryDataValues['template_category_id']) {
            params['template_category_id'] = categoryDataValues['template_category_id']
        }
        return params
    }
    return <BaseInfoView
        showComponent={showComponent}
        categoryData={categoryData}
        rowKey={props?.rowKey}
        apiRoute={apiRoute}
        getBaseCardViewData={propsGetBaseCardViewData ? propsGetBaseCardViewData : getBaseCardViewData}
        getBaseListViewData={propsGetBaseListViewData ? propsGetBaseListViewData : getBaseListViewData}
        baseInfoView5Props={{
            baseInfoView5_1props: {
                rowKey: props?.rowKey
            },
        }}
        baseTreeSelectorProps={{
            title: treeFilterTitle,
            filterComponentCols: 6,
            ...baseTreeSelectorProps
        }}
        reloadCount={reloadCount}
        reloadAndResetCount={reloadAndResetCount}
        getParams={propsGetParams ? propsGetParams : (propsGetCategoryParams ? propsGetCategoryParams : getParams)}
        searchTextConfig={searchTextConfig}
        viewModeTextConfig={viewModeTextConfig}
        categoryTabTextConfig={categoryTabTextConfig}
        showTreeFilter={showTreeFilter}
        FilterComponent={FilterComponent}
        multipleEditComponent={multipleEditComponent}
        showCardContent={showCardContent}
        FilterComponentCols={FilterComponentCols}
        CardContentData={CardContentData}
        {...props}
    />

}
export default CrmInfoView
